import { Col, Form, FormGroup, Row } from 'react-bootstrap';
import { ProjectGroupReleaseProject } from '../../../../types';
import ProjectGroupReleaseProjectsTable from '../components/ProjectGroupReleaseProjectsTable';
import ReleaseHelp from '../components/ReleaseHelp';

type ConfirmProjectGroupProps = {
  title: string;
  release: string;
  releaseProjects: ProjectGroupReleaseProject[];
};

const ConfirmProjectGroup = ({
  releaseProjects = [],
  title = '',
  release = '',
}: ConfirmProjectGroupProps) => (
  <div className="confirm-select-projects">
    <Form>
      <Row>
        <Col xs={12}>
          <h4>3. Review New Project Group</h4>
        </Col>
      </Row>
      <Row>
        <Col xs={6}>
          <FormGroup>
            <p className="text-label">Title</p>
            <h3
              id="release-group-name"
              className="release-group-name"
            >
              {title}
            </h3>
          </FormGroup>
        </Col>
        <Col xs={6}>
          <FormGroup>
            <p className="text-label"> Initial Release <ReleaseHelp /></p>
            <h3 id="release-group-release">{release}</h3>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <p className="text-label">Projects</p>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <ProjectGroupReleaseProjectsTable
            sortableBranchCommit
            readOnly
            releaseProjects={releaseProjects}
          />
        </Col>
      </Row>
    </Form>
  </div>
);

export default ConfirmProjectGroup;
